<div class="snack-bar-container">
    <p matSnackBarLabel>{{message}}</p>
    <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_115_1558)">
                <path d="M1.25293 1.25293L20.747 20.747" stroke="#001F58" stroke-width="2" stroke-linecap="round" />
            </g>
            <g clip-path="url(#clip1_115_1558)">
                <path d="M20.747 1.25293L1.25293 20.747" stroke="#001F58" stroke-width="2" stroke-linecap="round" />
            </g>
            <defs>
                <clipPath id="clip0_115_1558">
                    <rect width="22" height="22" fill="white" />
                </clipPath>
                <clipPath id="clip1_115_1558">
                    <rect width="22" height="22" fill="white" />
                </clipPath>
            </defs>
        </svg>
    </button>
</div>